const Dialogs = Object.freeze({
  CONFIRMATION: 'confirmation',
  CONSTITUENT_BULK_EDIT_BOARDS: 'constituent-bulk-edit-boards',
  CONSTITUENT_BULK_EDIT_LABELS: 'constituent-bulk-edit-labels',
  CONSTITUENT_EXPORT_CHOICE: 'constituent-export-choice',
  CONSTITUENT_EXPORT_CSV: 'constituent-export-csv',
  CONSTITUENT_EXPORT_DESTINATION: 'constituent-export-destination',
  CONSTITUENT_LIFECYCLE_POSITION: 'constituent-lifecycle-position',
  CONSTITUENT_LIFECYCLE_POSITIONS: 'constituent-lifecycle-positions',
  CREATE_CUSTOM_FIELD: 'create-custom-field',
  CREATE_EDIT_CAMPAIGN_EVENT: 'create-edit-campaign-event',
  CREATE_EDIT_OPPORTUNITY: 'create-edit-opportunity',
  CREATE_EDIT_TICKET_OPTION: 'create-edit-ticket-option',
  CREATE_LIFECYCLE_BOARD: 'create-lifecycle-board',
  DONATION_FORM: 'donation-form',
  EXPORT_MESSAGE: 'export-message',
  INFORMATIONAL: 'informational',
  LABELS_EDIT: 'labels-edit',
  LINK_TO_DONATIONS: 'link-to-donations',
  LINK_TO_OPPORTUNITY: 'link-to-opportunity',
  LINK_TO_PLEDGE: 'link-to-pledge',
  MOVE_CAMPAIGN_EVENT: 'move-campaign-event',
  PLEDGE_INTEGRATION: 'pledge-integration',
});

export default Dialogs;
